import { FC, useEffect, useMemo, useState } from "react";
import { API, Designer, Lang, Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useModal } from "core";
import { useGetCommentsHandlers } from "shared/components/CommentsController/helpers/useGetCommentsHandlers";
import { IPost } from "shared/components/CommentsController/const/types";
import { hasHeadTextContent, normalizeHeadText } from "shared/contexts/VoteContext";
import {
    findHeadCommentForCompetition,
    getHeadTextFromComment,
} from "shared/pages/project/components/const/buildForProjectHeadUpdate";
import {
    CloseModalIconWrapper,
    HeadCommentAuthor,
    HeadCommentContent,
    HeadCommentHeader,
    HeadCommentModalBody,
    HeadCommentTitle,
} from "./styles";
import { Avatar, CommonInput, FlexBox, INPUT_TYPES } from "@brg/ui";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { computeDesigner } from "shared/helpers/computeData";
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import { formatDate } from "shared/components/CommentsController/helpers/formatDate";
import { InfoTime } from "shared/components/CommentsController/styles";

type Props = {
    project: Project;
    competitionId?: string;
};

const HEAD_PRACTICE_ENTITY_TYPE = "headpractice_project";

export const HeadCommentModal: FC<Props> = ({ project, competitionId }) => {
    const modal = useModal();
    const { i18n: { language } } = useTranslation();
    const { onGetComment } = useGetCommentsHandlers();
    const [comment, setComment] = useState<IPost | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!project) return;

        let cancelled = false;
        setIsLoading(true);

        onGetComment?.(project.projectId, HEAD_PRACTICE_ENTITY_TYPE)
            .then((res: IPost[] | unknown) => {
                if (cancelled) return;
                const list = (Array.isArray(res) ? res : []) as IPost[];
                if (competitionId) {
                    setComment(findHeadCommentForCompetition(list, competitionId));
                    return;
                }
                setComment(
                    list.find((item) => hasHeadTextContent(item.text))
                        ?? list[0]
                        ?? null
                );
            })
            .catch(() => {
                if (!cancelled) setComment(null);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [project.projectId, onGetComment, competitionId]);

    const localAccount = useMemo(() => {
        return API.toLang<Designer<'Local'>>(comment?.account, language);
    }, [comment?.account, language]);

    const computedAuthor = useMemo(() => {
        return computeDesigner(localAccount, { showFullName: true });
    }, [localAccount]);

    const projectTitle = useMemo(() => {
        return project.title;
    }, [project.title]);

    const authorTitle = useMemo(() => {
        const authorPrefix = language === 'ru' ? 'Автор:' : 'Author:';
        return `${authorPrefix} ${computedAuthor?.name} ${computedAuthor?.surName}`;
    }, [comment, language, computedAuthor]);

    const authorName = useMemo(() => {
        return computedAuthor?.fullName;
    }, [computedAuthor]);

    const commentText = useMemo(() => {
        const raw = getHeadTextFromComment(comment);
        if (!raw) return "";
        return Lang(normalizeHeadText(raw), language) ?? "";
    }, [comment, language]);

    if (isLoading) {
        return <LoaderSpinner />
    }

    if (!commentText) {
        return (
            <HeadCommentModalBody>
            <CloseModalIconWrapper>
                <CloseModalIconMob onClick={() => modal.hide()} />
            </CloseModalIconWrapper>
            <div style={{ textAlign: 'center', marginTop: 20 }}>{language === 'ru' ? 'Комментарий отсутствует' : 'Comment is absent'}</div>
            </HeadCommentModalBody>
        )
    }

    return (
        <HeadCommentModalBody>
            <CloseModalIconWrapper>
                <CloseModalIconMob onClick={() => modal.hide()} />
            </CloseModalIconWrapper>
            <HeadCommentHeader>
                <HeadCommentTitle>
                    {projectTitle}
                </HeadCommentTitle>
                <HeadCommentAuthor>
                    {authorTitle}
                </HeadCommentAuthor>
            </HeadCommentHeader>

            {!isLoading && !!commentText && (
                <HeadCommentContent>
                    <FlexBox align={'center'} gx={8} offsetLeft={16} offsetTop={16}>
                        <FlexBox width={48} height={48}>
                            <Avatar fs={48} {...computedAuthor} rounded />
                        </FlexBox>
                        <FlexBox gy={6} direction="column" directionMobile="column">
                            <InfoTime>{formatDate(comment?.created ?? '', language)}</InfoTime>
                            <span>{authorName}</span>
                        </FlexBox>
                    </FlexBox>
                    <CommonInput
                        type={INPUT_TYPES.textarea}
                        onChange={() => {}}
                        value={commentText}
                        minHeight={300}
                        maxHeight={800}
                        label={''}
                    />
                </HeadCommentContent>
            )}
        </HeadCommentModalBody>
    );
};
import { FC, useEffect, useMemo, useState } from "react";
import { API, Designer, Lang, Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useModal } from "core";
import { useGetCommentsHandlers } from "shared/components/CommentsController/helpers/useGetCommentsHandlers";
import { IPost } from "shared/components/CommentsController/const/types";
import { hasHeadTextContent, normalizeHeadText } from "shared/contexts/VoteContext";
import {
    findHeadCommentForCompetition,
    getHeadTextFromComment,
} from "shared/pages/project/components/const/buildForProjectHeadUpdate";
import {
    CloseModalIconWrapper,
    HeadCommentAuthor,
    HeadCommentContent,
    HeadCommentHeader,
    HeadCommentModalBody,
    HeadCommentTitle,
} from "./styles";
import { Avatar, CommonInput, FlexBox, INPUT_TYPES } from "@brg/ui";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { computeDesigner } from "shared/helpers/computeData";
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import { formatDate } from "shared/components/CommentsController/helpers/formatDate";
import { InfoTime } from "shared/components/CommentsController/styles";

type Props = {
    project: Project;
    competitionId?: string;
};

const HEAD_PRACTICE_ENTITY_TYPE = "headpractice_project";

export const HeadCommentModal: FC<Props> = ({ project, competitionId }) => {
    const modal = useModal();
    const { i18n: { language } } = useTranslation();
    const { onGetComment } = useGetCommentsHandlers();
    const [comment, setComment] = useState<IPost | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!project) return;

        let cancelled = false;
        setIsLoading(true);

        onGetComment?.(project.projectId, HEAD_PRACTICE_ENTITY_TYPE)
            .then((res: IPost[] | unknown) => {
                if (cancelled) return;
                const list = (Array.isArray(res) ? res : []) as IPost[];
                if (competitionId) {
                    setComment(findHeadCommentForCompetition(list, competitionId));
                    return;
                }
                setComment(
                    list.find((item) => hasHeadTextContent(item.text))
                        ?? list[0]
                        ?? null
                );
            })
            .catch(() => {
                if (!cancelled) setComment(null);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [project.projectId, onGetComment, competitionId]);

    const localAccount = useMemo(() => {
        return API.toLang<Designer<'Local'>>(comment?.account, language);
    }, [comment?.account, language]);

    const computedAuthor = useMemo(() => {
        return computeDesigner(localAccount, { showFullName: true });
    }, [localAccount]);

    const projectTitle = useMemo(() => {
        return project.title;
    }, [project.title]);

    const authorTitle = useMemo(() => {
        const authorPrefix = language === 'ru' ? 'Автор:' : 'Author:';
        return `${authorPrefix} ${computedAuthor?.name} ${computedAuthor?.surName}`;
    }, [comment, language, computedAuthor]);

    const authorName = useMemo(() => {
        return computedAuthor?.fullName;
    }, [computedAuthor]);

    const commentText = useMemo(() => {
        const raw = getHeadTextFromComment(comment);
        if (!raw) return "";
        return Lang(normalizeHeadText(raw), language) ?? "";
    }, [comment, language]);

    if (isLoading) {
        return <LoaderSpinner />
    }

    if (!commentText) {
        return (
            <HeadCommentModalBody>
            <CloseModalIconWrapper>
                <CloseModalIconMob onClick={() => modal.hide()} />
            </CloseModalIconWrapper>
            <div style={{ textAlign: 'center', marginTop: 20 }}>{language === 'ru' ? 'Комментарий отсутствует' : 'Comment is absent'}</div>
            </HeadCommentModalBody>
        )
    }

    return (
        <HeadCommentModalBody>
            <CloseModalIconWrapper>
                <CloseModalIconMob onClick={() => modal.hide()} />
            </CloseModalIconWrapper>
            <HeadCommentHeader>
                <HeadCommentTitle>
                    {projectTitle}
                </HeadCommentTitle>
                <HeadCommentAuthor>
                    {authorTitle}
                </HeadCommentAuthor>
            </HeadCommentHeader>

            {!isLoading && !!commentText && (
                <HeadCommentContent>
                    <FlexBox align={'center'} gx={8} offsetLeft={16} offsetTop={16}>
                        <FlexBox width={48} height={48}>
                            <Avatar fs={48} {...computedAuthor} rounded />
                        </FlexBox>
                        <FlexBox gy={6} direction="column" directionMobile="column">
                            <InfoTime>{formatDate(comment?.created ?? '', language)}</InfoTime>
                            <span>{authorName}</span>
                        </FlexBox>
                    </FlexBox>
                    <CommonInput
                        type={INPUT_TYPES.textarea}
                        onChange={() => {}}
                        value={commentText}
                        minHeight={300}
                        maxHeight={800}
                        label={''}
                    />
                </HeadCommentContent>
            )}
        </HeadCommentModalBody>
    );
};
